import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { KTIcon } from '../../../../_metronic/helpers'

const AssignedListingModal = ({
    listings,
    onClose
}) => {
    const navigate = useNavigate()

    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    return (
        <>
            <div
                className='modal fade show d-block'
                id='kt_modal_add_user'
                role='dialog'
                tabIndex={-1}
                aria-modal='true'
            >
                <div className={`modal-dialog modal-dialog-centered mw-500px`}>
                    <div className='modal-content'>
                        <div className='modal-header py-3'>
                            <h2 className='fw-bolder mb-0'>Assigned Listings</h2>
                            <div
                                className='btn btn-icon btn-sm btn-active-icon-primary'
                                data-kt-users-modal-action='close'
                                onClick={onClose}
                                style={{ cursor: 'pointer' }}
                            >
                                <KTIcon iconName='cross' className='fs-1' />
                            </div>
                        </div>
                        <div className={`modal-body scroll-y mx-5 mx-xl-5`}>
                            <div
                                className="d-flex flex-column scroll-y me-n7 mh-300px min-h-auto"
                            >
                                {listings?.sort((a, b) => a?.title - b?.title)?.map(el => (
                                    <div key={el?.id} className="d-flex align-items-center mb-5">
                                        <div className="text-hover-main fs-4 fw-bold me-5 pointer"
                                            onClick={() => {
                                                navigate(`/listings/${el?.id}`)
                                            }}
                                        >
                                            {el?.title}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="text-center pt-15">
                                <button
                                    type="reset"
                                    onClick={onClose}
                                    className="btn btn-light mx-3"
                                    data-kt-users-modal-action="cancel"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal-backdrop fade show'></div>
        </>
    )
}

export { AssignedListingModal }
